<template>
  <div>
    <van-cell is-link
              @click="showPopup">
      <!-- 学期 -->
      <div class="display-flex flex-ju-space-be"
           v-cloak>
        <p>学年：{{schoolYear}}</p>
        <p>学期：{{semester}}</p>
      </div>
    </van-cell>
    <van-popup v-model="show"
               round
               position="bottom"
               custom-style="height: 10%"
               :close="onClose">
      <van-picker :columns="yearList"
                  @change="onChange" />
    </van-popup>

    <div class="dorm"
         v-if="dormitoryData">
      <!-- <div v-if="dormitoryData" class="display-flex flex-ju-space-be dorm"> -->
      <p>您所在宿舍：</p>
      <p>{{dormitoryData.SchoolDistrictName}}-{{dormitoryData.BuildingName }}-{{dormitoryData.DormName}}</p>
    </div>
    <no-data v-if="!dormitoryData"
             :needBg="true"></no-data>
  </div>
</template>

<script>
import '@/assets/styles/flexCss/Index.less'
import noData from '@/components/noData/Index'
export default {
  name: 'Index',
  components: {
    noData
  },
  data () {
    return {
      show: false,
      yearData: [],
      yearID: null,
      sessionData: [],
      schoolYear: '', // 学年
      semester: '', // 学期
      AcademicSessionID: null,
      yearList: [

        {
          values: [],
          className: 'column1',
          defaultIndex: (this.yearData && this.yearData.length > 0 ? this.yearData[this.yearData.length - 1] : '') || 1
        },
        {
          values: [],
          className: 'column2',
          defaultIndex: 1
        }

      ],
      dormitoryData: null,
    }
  },
  created () {
    this.getYear()
  },
  methods: {

    onChange (picker, value, index) {
      if (0 === index) {
        if (this.yearID === this.yearData[picker.getIndexes()[0]].ID) return
        this.yearID = this.yearData[picker.getIndexes()[0]].ID
        this.schoolYear = this.yearData[picker.getIndexes()[0]].Name
        this.getSession(this.yearData[picker.getIndexes()[0]].ID)
      } else {
        if (this.AcademicSessionID === this.sessionData[picker.getIndexes()[1]].AcademicSessionID) return
        this.AcademicSessionID = this.sessionData[picker.getIndexes()[1]].AcademicSessionID
        this.semester = this.sessionData[picker.getIndexes()[1]].AcademicSessionName
        this.getByUserID(this.sessionData[picker.getIndexes()[1]].AcademicSessionID)
      }
    },
    showPopup () {
      this.show = true
    },
    onClose () {
      this.show = false
    },
    //获取学年
    async getYear () {
      this.xy.loading()
      let res = await this.xyapi.get(this.xyMApi + "/xy/comm/YearList")
      this.xy.unloading()
      if (res.success) {
        this.yearData = res.data
        if (res.data && res.data.length > 0) {
          this.yearList[0].values = this.yearData.map((val) => {
            return val.Name
          })
          var arr = res.data.filter(function (item) { return item.IsCurrent === true; })
          if (arr.length > 0) {
            this.schoolYear = arr[arr.length - 1].Name
            this.yearID = arr[arr.length - 1].ID
          } else {
            this.schoolYear = res.data[res.data.length - 1].Name
            this.yearID = res.data[res.data.length - 1].ID
          }
        }
        this.getSession(this.yearID)
      } else {
        this.$toast.fail(res.data)
      }
    },
    //获取学期
    async getSession (id) {
      this.xy.loading()
      let res = await this.xyapi.get(this.xyMApi + "/xy/comm/SessionList", { yearID: id })
      this.xy.unloading()
      if (res.success) {
        if (res.data && res.data.length > 0) {
          this.sessionData = res.data
          this.AcademicSessionID = res.data[0].AcademicSessionID
          // 写这个是为了让vant组件监听到数组里面数据的变化
          this.yearList.pop()

          this.yearList[1] = {
            values: res.data.map((val) => {
              return val.AcademicSessionName
            }),
            className: 'column2'
          }
          this.semester = res.data[0].AcademicSessionName
          this.getByUserID(res.data[0].AcademicSessionID)
        }
      } else {
        this.$toast.fail(res.data)
      }
    },
    //获取学期
    async getByUserID (id) {
      this.xy.loading()
      let res = await this.xyapi.get(this.$store.state.apiPath + "/api/Dorm/GetByUserID", { academicSessionID: id })
      this.xy.unloading()
      // console.log(res)
      if (res.success) {
        if (res.data) {
          this.dormitoryData = res.data
        } else {
          this.dormitoryData = null
        }
      } else {
        this.$toast.fail(res.data)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dorm {
  padding: 20px;
  font-size: 30px;
  background-color: #fff;
  color: #666;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  p {
    min-height: 50px;
    line-height: 1.5;
  }
}
</style>